import axios from 'axios';

export default class CrudService {
    async get(url, token = "") {
        try{
            let res = await axios.get(`https://sig.plataformasig.com.br/sig/api/${url}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async post(url, obj, token = "") {
        try{
            let res = await axios.post(`https://sig.plataformasig.com.br/sig/api/${url}`, 
                                    JSON.stringify(obj), {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: `Bearer ${token}`
                                    }
                                });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async patch(url, obj, token = "") {
        try{
            let res = await axios.patch(`https://sig.plataformasig.com.br/sig/api/${url}`, 
                                    JSON.stringify(obj), {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: `Bearer ${token}`
                                    }
                                });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async put(url, obj, token = "") {
        try{
            let res = await axios.put(`https://sig.plataformasig.com.br/sig/api/${url}`, 
                                    JSON.stringify(obj), {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: `Bearer ${token}`
                                    }
                                });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async delete(url, token = "") {
        try{
            let res = await axios.delete(`https://sig.plataformasig.com.br/sig/api/${url}`, 
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: `Bearer ${token}`
                                    }
                                });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async postWithFile(url, obj, token = "") {
        try{
            let res = await axios.post(`https://sig.plataformasig.com.br/sig/api/${url}`, 
                                    obj, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        Authorization: `Bearer ${token}`
                                    }
                                });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async patchWithFile(url, obj, token = "") {
        try{
            let res = await axios.patch(`https://sig.plataformasig.com.br/sig/api/${url}`, 
                                    obj, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        Authorization: `Bearer ${token}`
                                    }
                                });
            return res;
        }
        catch(error){
            return error.response;
        }
    }

    async downloadFile(url, filename, token = ""){
        axios({
            url: `https://sig.plataformasig.com.br/sig/api/${url}`,
            headers: { Authorization: `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        });
    }
}